import {combineReducers} from 'redux';
import {
  checkAuthStatus as checkAuthStatusAPI,
  registerAuthListener as registerAuthListenerAPI,
  loginGoogle,
  loginFacebook,
  logout as logoutAPI,
} from '../module/API';

const extractRelevantAuthData = (auth) => {
  const {uid, displayName} = auth;
  return {
    uid,
    displayName,
  };
};

// *** REDUCERS

const authReducer = (state = false, action) => {

  switch(action.type) {

    case 'LOGIN_SUCCESS':
      return true;

    case 'LOGOUT_SUCCESS':
    case 'LOGIN_ERROR':
      return false;

    default:
      return state;

  }

};

const loadingReducer = (state = false, action) => {

  switch(action.type) {

    case 'CHECKING_AUTH_STATUS':
      return true;

    case 'LOGIN_SUCCESS':
    case 'LOGIN_ERROR':
    case 'LOGOUT_SUCCESS':
      return false;

    default:
      return state;

  }

}

const errorReducer = (state = null, action) => {

  switch(action.type) {

    case 'CHECKING_AUTH_STATUS':
    case 'LOGIN_SUCCESS':
      return null;

    case 'LOGIN_ERROR':
      return action.error;

    default:
      return state;

  }

}

const userDataReducer = (state = {}, action) => {

  switch(action.type) {

    case 'LOGIN_SUCCESS':
      return {...action.data};

    case 'LOGOUT_SUCCESS':
      return {};

    default:
      return state;

  }

};

// *** MAIN REDUCER

export default combineReducers({
  authenticated: authReducer,
  loading: loadingReducer,
  error: errorReducer,
  data: userDataReducer,
});

// *** SELECTORS

export const authStatusSelector = (state) => state.authenticated ? true : false;
export const checkingAuthStatusSelector = (state) => state.loading ? true : false;
export const loginErrorSelector = (state) => state.error;
export const userDataSelector = (state) => state.data;
export const userIdSelector = (state) => userDataSelector(state).uid;
export const userNameSelector = (state) => userDataSelector(state).displayName;

// *** ACTIONS

export const checkAuthStatus = () => {
  return (dispatch) => {
    dispatch({
      type: 'CHECKING_AUTH_STATUS',
    });
    return checkAuthStatusAPI().then(auth => {
      if ( auth ) {
        dispatch({
          type: 'LOGIN_SUCCESS',
          data: extractRelevantAuthData(auth),
        });
      }
    }).catch(err => {
      dispatch({
        type: 'LOGIN_ERROR',
        error: err.message,
      });
    }).catch(err => {
      dispatch({
        type: 'LOGIN_ERROR',
        error: err.message,
      });
    });
  };
};

export const registerAuthListener = () => {
  return (dispatch) => {
    dispatch({
      type: 'CHECKING_AUTH_STATUS'
    });
    registerAuthListenerAPI(auth => {
      if ( auth ) {
        dispatch({
          type: 'LOGIN_SUCCESS',
          data: extractRelevantAuthData(auth),
        });
      } else {
        dispatch({
          type: 'LOGOUT_SUCCESS',
        });
      }
    });
  };
};

export const loginViaGoogle = () => {
  return (dispatch) => {
    loginGoogle().catch(err => {
      dispatch({
        type: 'LOGIN_ERROR',
        error: err.message,
      });
    });
  };
};

export const loginViaFacebook = () => {
  return (dispatch) => {
    loginFacebook().catch(err => {
      dispatch({
        type: 'LOGIN_ERROR',
        error: err.message,
      });
    });
  };
};

export const logout = () => {
  return (dispatch) => {
    logoutAPI();
    dispatch({
      type: 'LOGOUT_SUCCESS',
    });
  };
};



// WEBPACK FOOTER //
// ./src/reducers/userReducer.js